<template>
  <div>
 

 <div style="min-height:120px;"></div>
    
    
 <div class="container-fluid mt--6">
    

      <!--start new row-->
      
      <div class="row">
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              
              <h3 slot="header" class="mb-0">Update User Info</h3>
              
              <!-- Card body -->
              <form class="needs-validation"   @submit.prevent="submit_form">
                <!-- Input groups with icon -->
        		
        		 <div class="row">
                  <div class="col-md-6">
                  	<div style="margin-bottom:30px">
            			<h4>Email</h4>
          				{{model.user.email}}
        			</div>
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                 
                <div class="row">
                  <div class="col-md-6">
                  
                  <base-input label="Name Of User"
                      name="user name"
                      required
                      v-model="model.user.user_info.name">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                 
                 
                 <div class="row">
                  <div class="col-md-6">
                  
                  <base-input label="Contact Number"
                      name="contact number"
                      
                      v-model="model.user.user_info.contact_number">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                  <div class="row">
                  <div class="col-md-12">
                  
                  <base-input label="Address"
                      name="address"
                      
                      v-model="model.user.user_info.address">
          			</base-input>
          
          
        
                  </div>
                
                </div>
                
                 <!-- end row -->
                 
                 
                 
                
                  
                
                <div>
                
                	<base-button type="info" block native-type="submit">Update User</base-button>

                </div>
              
              </form>
            </card>
            </div>
            </div>
            </div>
            
      
      
      
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>
  import { Select, Option, Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  

  export default {
    components: {
  	  [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      TabPane,
      Tabs,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
     	 brand_options:[],
     	 
     	 is_create: 1,
     	 model:{
     	 	role:'',
     	 	user:{
     	 		user_info:{
     	 			name:'',
     	 		},
     	 	}

     	 },
     	 et_type_options:[],
     	 et_subtype_options:[],
     	 et_subtype_all_options:[],
     	 selectOptions: [
          {
            label: 'Alerts',
            value: 'Alerts'
          },
          {
            label: 'Badges',
            value: 'Badges'
          },
        ],
	
      };
    },
    methods: {
  		submit_form(){
  				swal.showLoading();
  				var vm = this;
  				
  				
  				let uri = vm.$base_url+'/api/clients/post/update_user';
				ApiService.post(uri, vm.model).then(response => {
				
					var msg = "User Updated.";
					
					
					
					
			 		if(response.data.success == "y"){
			 				swal.fire({
									title: `Success`,
									text: msg,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'success'
							}).then((result)=> {	
				  
				  		 			if (result.isConfirmed) {
				  		 				this.$router.push( '/manage-users')
				  		 			
				  		 			}
				  		 
				  			 });
			 		}
			 		else{
			 			swal.fire({
									title: 'Error',
									text: response.data.error,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'warning'
							});
			 			
			 		}
			 })//end api service
  		},
  		et_change(){
  			
  			this.et_subtype_options = this.et_subtype_all_options[this.model.equipment_type_id][0];
  			this.model.equipment_subtype_id = this.et_subtype_options[0]['value'];
			
  		},
  	
  		page_load(){
  			swal.showLoading();

  			let uri = this.$base_url+'/api/clients/get/user_info/' + this.$route.params.uid;
			ApiService.get(uri).then(response => {
			 

					 this.model = response.data.user;
					  swal.close();
   					
   					 
			})
				
				
  			
			
  		
  		
  		},
  		to_confirm(){
  			
  		
  			var vm = this;
  			swal.fire({
					title: 'Are you sure?',
					text: 'You are changing the password for the virtual tour to:     '+ this.model.code,
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes, proceed.',
					buttonsStyling: false
				  }).then((result)=> {	
				  
				  		 if (result.isConfirmed) {
				  		 	 var $base_url = "https://kh.rollingatlas.com/kh/public";
				  			 let uri = vm.$base_url+'/api/change_code';
							 ApiService.post(uri, vm.model).then(response => {
			 						if(response.data.success == "y"){
			 							vm.code = response.data.code;
			 							swal.fire({
												title: `Success`,
												text: 'Virtual Tour Password Updated.',
												buttonsStyling: false,
												confirmButtonClass: 'btn btn-success',
												icon: 'success'
										 });
			 						}
			 				})
				  		 
				  		 }
				  		 else{
				  		 
				  		 
				  		 }
				  			
			 
					}
					
					)//end swal

  		}
    },
    mounted() {
      	
      	this.page_load();
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














